import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebase";
import NotFoundImg from "../../assets/images/not-found.png";

const NotFound = () => {
	const [isLoggedIn, setIsLoggedIn] = useState(false);

	useEffect(() => {
		const unsubscribe = onAuthStateChanged(auth, (user) => {
			setIsLoggedIn(!!user);
		});
		return () => unsubscribe();
	}, []);

	return (
		<div className="flex items-center justify-center h-screen w-full p-10">
			<img src={NotFoundImg} alt="" className="w-1/2" />

			<div className="flex flex-col justify-center gap-4 w-1/2">
				<h3 className="font-bold text-xl ">Error 404</h3>
				<h2 className="text-6xl font-extrabold">Page Not Found!</h2>
				<p className="max-w-sm text-gray-600 mb-10 text-sm">
					Looks like the page you're trying to access does not exist or been
					removed.
				</p>

				{isLoggedIn ? (
					<Link
						to="/dashboard"
						className="text-center w-1/2 bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 cursor-pointer"
					>
						Go back to Dashboard
					</Link>
				) : (
					<Link
						to="/"
						className="text-center w-1/2 bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 cursor-pointer"
					>
						Go back to Login
					</Link>
				)}
			</div>
		</div>
	);
};

export default NotFound;
